var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColumnsFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99878 14.9558C5.74105 14.9558 5.53211 14.7469 5.53211 14.4891L5.53211 2.32292C5.53211 2.06519 5.74105 1.85626 5.99878 1.85626C6.25651 1.85626 6.46545 2.06519 6.46545 2.32292L6.46545 14.4891C6.46545 14.7469 6.25651 14.9558 5.99878 14.9558Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3217 14.9558C10.064 14.9558 9.85503 14.7469 9.85503 14.4891L9.85503 2.32292C9.85503 2.06519 10.064 1.85626 10.3217 1.85626C10.5794 1.85626 10.7884 2.06519 10.7884 2.32292L10.7884 14.4891C10.7884 14.7469 10.5794 14.9558 10.3217 14.9558Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1878 2.73802H2.81742C2.51469 2.73802 2.26927 2.98344 2.26927 3.28617V13.6565C2.26927 13.9593 2.51468 14.2047 2.81742 14.2047H13.1878C13.4905 14.2047 13.7359 13.9593 13.7359 13.6565V3.28617C13.7359 2.98343 13.4905 2.73802 13.1878 2.73802ZM2.81742 1.80469H13.1878C14.006 1.80469 14.6693 2.46797 14.6693 3.28617V13.6565C14.6693 14.4747 14.006 15.138 13.1878 15.138H2.81742C1.99922 15.138 1.33594 14.4747 1.33594 13.6565V3.28617C1.33594 2.46797 1.99922 1.80469 2.81742 1.80469Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnsFilterIcon);
export default __webpack_public_path__ + "static/media/columns-filter-icon.b11f777ac90f7c9f2b29bbbbec5aa690.svg";
export { ForwardRef as ReactComponent };